__turbopack_context__.v({
  "dayAndMonth": "Q7xl_q_dayAndMonth",
  "dayWrapper": "Q7xl_q_dayWrapper",
  "weekday": "Q7xl_q_weekday",
});
